import type { LoadingScreenModel } from './LoadingScreenModelScreen';

export class LoadingScreenController {
  constructor(private readonly _model: LoadingScreenModel) {}
}
